import WecomCommand from "./wecom-command";
import WechatCommand from "./wechat-command";

const Command = {
  WecomCommand,
  WechatCommand,
};

export default Command;
